import React from 'react'
import styles from './index.module.css'

/**
 * A component that displays content in an empty state layout with centered styling
 * @param children - The content to display in the empty state
 * @returns A centered empty state container with the provided content
 */
const EmptyState = props => (
  <div className={styles.emptyState}>
    <div className={styles.emptyStateContent}>{props.children}</div>
  </div>
)

export default React.memo(EmptyState)
